<script>
export default {
  name: "wizard-locations",
  data() {
    return {
      loading: true,
      locations: [],
      selected: [],
      search: "",
      headers: [
        {
          text: "Name",
          align: "left",
          sortable: true,
          value: "name"
        },
        { text: "Street", value: "street" },
        { text: "City", value: "city" },
        { text: "State", value: "state" }
      ]
    };
  },
  mounted() {
    this.locations = this.$store.getters["getLocations"];
  },
  watch: {
    selected(newVal) {
      this.$emit("input", newVal);
    }
  }
};
</script>

<template>
  <v-card flat>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="locations"
      item-key="id"
      :sort-by="['name']"
      show-select
      class="elevation-1"
      :search="search"
      loading-text="Loading... Please wait"
    >
    </v-data-table>
  </v-card>
</template>
